(function(){
const ROOT = document.getElementById('oc-app');
const P = window.OC_PRODUCTS || {};
const $ = s => ROOT.querySelector(s);
const esc = s => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
ROOT.innerHTML = `<header><img src="${window.OC_LOGO}" alt=""><span class="brand">Offcourt</span><span class="t">Schläger-Finder</span></header><main id="oc-main"></main>`;

/* b = Punkte für Balance (rund, Kontrolle), p = Punkte für Performance (Tropfen, Power) */
const Q = [
  {q:'Wie lange spielst du schon Padel?', o:[
    {t:'Ich fange gerade an', s:'Noch keine oder nur wenige Matches', b:3, why:'Du startest gerade – ein runder Schläger verzeiht mehr Fehler.'},
    {t:'Ein paar Monate bis 2 Jahre', s:'Die Grundschläge sitzen', b:1, p:1},
    {t:'Länger als 2 Jahre', s:'Ich spiele regelmäßig Matches', p:3, why:'Mit deiner Erfahrung holst du mehr aus der Tropfenform heraus.'}]},
  {q:'Wie oft stehst du auf dem Court?', o:[
    {t:'Ab und zu', s:'Ein paar Mal im Monat', b:1},
    {t:'Einmal pro Woche', s:'Fester Termin', b:0},
    {t:'Zweimal pro Woche oder öfter', s:'Padel ist mein Sport', p:1}]},
  {q:'Was ist dir im Spiel am wichtigsten?', o:[
    {t:'Kontrolle und Sicherheit', s:'Ball im Spiel halten, wenig Fehler', b:3, why:'Dir ist Kontrolle wichtig – genau dafür ist der Balance gebaut.'},
    {t:'Eine gute Mischung', s:'Sicher spielen, aber auch mal angreifen', b:1, p:1},
    {t:'Power im Angriff', s:'Volleys und Smashes, die sitzen', p:3, why:'Du willst angreifen – die Tropfenform bringt mehr Power in Volley und Smash.'}]},
  {q:'Wie oft spielst du Überkopfbälle wie Bandeja oder Smash?', o:[
    {t:'Selten', s:'Ich bleibe meist hinten', b:2},
    {t:'Manchmal', s:'Wenn sich die Chance ergibt', b:0},
    {t:'Ständig', s:'Ich will ans Netz und abschließen', p:2, why:'Viele Überkopfbälle sprechen für mehr Schlagkraft am Netz.'}]},
  {q:'Hast du schon einen anderen Schlägersport gespielt?', o:[
    {t:'Nein', s:'Padel ist mein erster', b:1},
    {t:'Ja, Tennis oder Squash', s:'Schlägergefühl ist schon da', p:1}]},
  {q:'Welche Farbe gefällt dir?', color:true, o:[
    {t:'Schwarz/Gelb', s:'Klassisch und dunkel', c:'s'},
    {t:'Weiß/Pink', s:'Hell und auffällig', c:'w'}]}
];
let A = [];

function render(){
  const step = A.length;
  $('#oc-main').innerHTML = step < Q.length ? viewQ(step) : viewResult();
  ROOT.querySelectorAll('[data-o]').forEach(b => b.onclick = () => { A.push(+b.dataset.o); render(); ROOT.scrollIntoView({block:'start', behavior:'smooth'}); });
  const bk = $('#back'); if (bk) bk.onclick = () => { A.pop(); render(); };
  const re = $('#restart'); if (re) re.onclick = () => { A = []; render(); };
}
function viewQ(i){
  const q = Q[i];
  return `<div class="stack">
  <div><h1>Welcher Schläger passt zu dir?</h1><div class="sub">${Q.length} kurze Fragen – danach bekommst du eine klare Empfehlung.</div></div>
  <div class="prog" aria-hidden="true">${Q.map((_, k) => `<span class="${k < i ? 'd' : ''}"></span>`).join('')}</div>
  <div class="card stack"><div class="lbl">Frage ${i + 1} von ${Q.length}</div><h2>${q.q}</h2>
  <div class="opts">${q.o.map((o, k) => `<button class="opt" type="button" data-o="${k}"><b>${o.t}</b><span>${o.s}</span></button>`).join('')}</div></div>
  ${i ? '<button class="btn ghost" id="back" style="align-self:flex-start">Zurück</button>' : ''}
  </div>`;
}
function viewResult(){
  let b = 0, p = 0, why = [], color = 's';
  A.forEach((k, i) => { const o = Q[i].o[k]; b += o.b || 0; p += o.p || 0; if (o.why) why.push(o.why); if (o.c) color = o.c; });
  const perf = p > b;
  const key = (perf ? 'p' : 'b') + color, pr = P[key] || {}, other = P[(perf ? 'b' : 'p') + color] || {};
  const share = Math.round(Math.max(b, p) / Math.max(1, b + p) * 100);
  if (!why.length) why.push(perf ? 'Deine Antworten zeigen: Du willst das Spiel aktiv gestalten.' : 'Deine Antworten zeigen: Sicherheit und saubere Technik stehen bei dir vorne.');
  why.push(perf ? 'Tropfenform (Teardrop): Sweet Spot etwas höher – mehr Power, trotzdem kontrollierbar.' : 'Runde Form: großer, zentraler Sweet Spot – fehlerverzeihend und leicht zu führen.');
  why.push('Full Carbon bei beiden Modellen: stabil, präzise und langlebig.');
  const set = P.set || {};
  return `<div class="stack">
  <div><span class="match">Deine Empfehlung</span><h1 style="margin-top:10px">${perf ? 'Padelschläger Performance' : 'Padelschläger Balance'}</h1>
  <div class="sub">${perf ? 'Für Spieler, die angreifen wollen – mit Power aus der Tropfenform.' : 'Für mehr Kontrolle und schnellen Fortschritt – mit runder Form.'}</div></div>
  <div class="card"><div class="prod">${pr.img ? `<img src="${esc(pr.img)}" alt="${esc(pr.title)}" width="600" height="600" loading="lazy">` : ''}
    <div class="stack" style="gap:10px"><b style="font-size:18px">${esc(pr.title || '')}</b><span class="price">${esc(pr.price || '')}</span>
    <ul class="why">${why.map(w => `<li>${esc(w)}</li>`).join('')}</ul>
    ${pr.url ? `<a class="btn" href="${esc(pr.url)}" style="align-self:flex-start">Zum Schläger</a>` : ''}</div></div></div>
  <div class="note">Deine Antworten passen zu ${share} % zu dieser Schlägerform. ${other.url ? `Knapp dran? Schau dir auch den <a href="${esc(other.url)}">${esc(other.title)}</a> an.` : ''}</div>
  ${set.url ? `<div class="card stack"><div class="lbl">Alles auf einmal</div><b>${esc(set.title)}</b><div class="note">Schläger nach Wahl, Lifestyle Bag und Padelbälle – günstiger als einzeln.${set.price ? ' Ab ' + esc(set.price) + '.' : ''}</div><a class="btn sec" href="${esc(set.url)}" style="align-self:flex-start">Zum Padel Set</a></div>` : ''}
  <div class="upsell"><div><b>Gratis dazu</b></div><div style="font-size:14px;color:#d7e6ec">Zu jedem Offcourt-Schläger bekommst du unseren 6-Wochen-Trainingsplan als PDF.</div></div>
  <div class="row"><button class="btn ghost" id="restart">Noch mal starten</button><a class="note" href="/blogs/neuigkeiten/welcher-padelschlager-passt-zu-mir-der-grosse-schlager-ratgeber">Mehr dazu im Schläger-Ratgeber</a></div>
  </div>`;
}
render();
})();